import { render, staticRenderFns } from "./detailsDevoirParent.vue?vue&type=template&id=248f9aee&"
import script from "./detailsDevoirParent.vue?vue&type=script&lang=js&"
export * from "./detailsDevoirParent.vue?vue&type=script&lang=js&"
import style0 from "./detailsDevoirParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports